// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Theming
 */
 .bio-properties-panel,
 .djs-parent {
  --color-grey-225-10-15: hsl(225, 10%, 15%);
  --color-grey-225-10-35: hsl(225, 10%, 35%);
  --color-grey-225-10-55: hsl(225, 10%, 55%);
  --color-grey-225-10-75: hsl(225, 10%, 75%);
  --color-grey-225-10-80: hsl(225, 10%, 80%);
  --color-grey-225-10-85: hsl(225, 10%, 85%);
  --color-grey-225-10-90: hsl(225, 10%, 90%);
  --color-grey-225-10-95: hsl(225, 10%, 95%);
  --color-grey-225-10-97: hsl(225, 10%, 97%);
  --color-grey-0-0-22: hsl(0, 0%, 22%);

  --color-blue-205-100-35: hsl(205, 100%, 35%);
  --color-blue-205-100-45: hsl(205, 100%, 45%);
  --color-blue-205-100-50: hsl(205, 100%, 50%);
  --color-blue-205-100-85: hsl(205, 100%, 85%);
  --color-blue-205-100-95: hsl(205, 100%, 95%);
  --color-blue-219-99-53: hsl(219, 99%, 53%);
  --color-blue-218-100-74: hsl(218, 100%, 74%);
  --color-green-150-86-44: hsl(150, 86%, 44%);

  --color-red-360-100-40: hsl(360, 100%, 40%);
  --color-red-360-100-45: hsl(360, 100%, 45%);
  --color-red-360-100-92: hsl(360, 100%, 92%);
  --color-red-360-100-97: hsl(360, 100%, 97%);
  --color-white: white;
  --color-black: black;
  --color-transparent: transparent;

}

.bio-properties-panel {
  --text-base-color: var(--color-grey-225-10-15);
  --text-error-color: var(--color-red-360-100-45);
  --link-color: var(--color-blue-205-100-50);

  --description-color: var(--color-grey-225-10-35);
  --description-code-background-color: var(--color-grey-225-10-97);
  --description-code-border-color: var(--color-grey-225-10-85);
  --description-list-item-color: var(--color-grey-225-10-35);

  --placeholder-color: var(--color-grey-225-10-35);
  --placeholder-background-color: var(--color-grey-225-10-95);

  --header-background-color: var(--color-grey-225-10-95);
  --header-icon-fill-color: var(--color-grey-225-10-15);
  --header-bottom-border-color: var(--color-grey-225-10-75);

  --group-background-color: var(--color-white);
  --group-bottom-border-color: var(--color-grey-225-10-75);

  --sticky-group-background-color: var(--color-grey-225-10-95);
  --sticky-group-bottom-border-color: var(--color-grey-225-10-75);

  --add-entry-fill-color: var(--color-grey-225-10-35);
  --add-entry-hover-fill-color: var(--color-white);
  --add-entry-hover-background-color: var(--color-blue-205-100-50);
  --add-entry-label-color: var(--color-white);

  --remove-entry-fill-color: var(--color-red-360-100-45);
  --remove-entry-hover-background-color: var(--color-red-360-100-92);

  --arrow-fill-color: var(--color-grey-225-10-35);
  --arrow-hover-background-color: var(--color-grey-225-10-95);

  --dot-color: var(--color-grey-225-10-35);
  --dot-color-error: var(--color-red-360-100-45);

  --list-badge-color: var(--color-white);
  --list-badge-background-color: var(--color-grey-225-10-35);

  --input-background-color: var(--color-grey-225-10-97);
  --input-border-color: var(--color-grey-225-10-75);

  --input-focus-background-color: var(--color-blue-205-100-95);
  --input-focus-border-color: var(--color-blue-205-100-50);

  --input-error-background-color: var(--color-red-360-100-97);
  --input-error-border-color: var(--color-red-360-100-45);
  --input-error-focus-border-color: var(--color-red-360-100-45);

  --input-disabled-color: var(--color-grey-225-10-55);
  --input-disabled-background-color: var(--color-grey-225-10-97);
  --input-disabled-border-color: var(--color-grey-225-10-90);

  --toggle-switch-on-background-color: var(--color-blue-205-100-50);
  --toggle-switch-off-background-color: var(--color-grey-225-10-75);
  --toggle-switch-switcher-background-color: var(--color-white);

  --side-line-background-color: var(--color-grey-225-10-35);
  --side-line-extension-background-color: var(--color-grey-225-10-35);

  --list-entry-dot-background-color: var(--color-grey-225-10-35);
  --list-entry-header-button-fill-color: var(--color-grey-225-10-35);
  --list-entry-add-entry-empty-background-color: var(--color-blue-205-100-50);
  --list-entry-add-entry-empty-hover-background-color: var(--color-blue-205-100-45);
  --list-entry-add-entry-label-color: var(--color-white);
  --list-entry-add-entry-background-color: var(--color-blue-205-100-50);
  --list-entry-add-entry-fill-color: var(--color-white);

  --dropdown-item-background-color: var(--color-white);
  --dropdown-item-hover-background-color: var(--color-grey-225-10-95);
  --dropdown-separator-background-color: var(--color-grey-225-10-75);

  --feel-background-color: transparent;
  --feel-active-color: var(--color-blue-205-100-45);
  --feel-inactive-color: var(--color-grey-225-10-35);
  --feel-hover-color: var(--color-grey-225-10-15);
  --feel-hover-background-color: var(--color-grey-225-10-97);
  --feel-active-background-color: transparent;
  --feel-required-color: var(--color-grey-225-10-55);
  --feel-open-popup-color: hsla(0, 0%, 32%, 1);
  --feel-open-popup-background-color: var(--color-white);
  --feel-open-popup-hover-color: hsla(219, 99%, 53%, 1);

  --feel-indicator-background-color: var(--color-grey-225-10-90);

  --feelers-select-color:  var(--color-blue-205-100-85);

  --text-size-base: 14px;
  --text-size-small: 13px;
  --text-size-smallest: 12px;
  --text-line-height: 21px;
  --line-height-condensed: 17px;

  --font-family: sans-serif;
  --font-family-monospace: monospace;

  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.bio-properties-panel {
  color: var(--text-base-color);
}

.bio-properties-panel * {
  font-size: var(--text-size-base);
  line-height: var(--text-line-height);
  font-weight: 400;
  box-sizing: border-box;
}

.bio-properties-panel {
  font-family: var(--font-family);
}

/**
 * Placeholder (empty, multi select, ...)
 */
.bio-properties-panel-placeholder {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--placeholder-background-color);
}

.bio-properties-panel-placeholder-text {
  color: var(--placeholder-color);
  font-size: var(--text-size-base);
  text-align: center;
  margin: 12px 48px;
}

/**
 * Header
 */
.bio-properties-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: var(--text-size-base);
  padding: 16px 10px;
  background-color: var(--header-background-color);
  border-bottom: 1px solid var(--header-bottom-border-color);
  width: 100%;
  z-index: 10;
  max-height: 64px;
  overflow: hidden;
}

.bio-properties-panel-header-icon {
  fill: var(--header-icon-fill-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.bio-properties-panel-header-labels {
  overflow: hidden;
  margin-left: 12px;
  user-select: none;
}

.bio-properties-panel-header-type {
  font-size: var(--text-size-smallest);
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: uppercase;
}

.bio-properties-panel-header-label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: -6px;
}

.bio-properties-panel-header-actions {
  margin-left: auto;
  margin-top: auto;
}

/**
 * Scroll container
 */
.bio-properties-panel-scroll-container {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

/**
 * Groups
 */
.bio-properties-panel-group {
  background-color: var(--group-background-color);
  border-bottom: 1px solid var(--group-bottom-border-color);
  position: relative;
}

.bio-properties-panel-group-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: var(--text-size-base);
  height: 32px;
  user-select: none;
  justify-content: space-between;
  margin-bottom: -1px; /* avoid double borders */
  position: relative;  /* browsers not supporting sticky */
  position: -webkit-sticky;  /* for safari */
  position: sticky;
  top: 0;
  z-index: 10;
}

.bio-properties-panel-group-header .bio-properties-panel-group-header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 1px 12px 0;
}

.bio-properties-panel-group-header.open .bio-properties-panel-group-header-title {
  font-weight: 500;
}

.bio-properties-panel-group-header.sticky {
  background-color: var(--sticky-group-background-color);
  border-bottom: 1px solid var(--sticky-group-bottom-border-color);
}

.bio-properties-panel-group-header-buttons {
  display: flex;
}

.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 22px;
  line-height: 22px;
  min-width: 22px;
  margin: 5px;
  padding: 0 3px;
  border: none;
  background: none;
}

.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-buttons:last-child {
  margin-right: 0;
}

.bio-properties-panel-add-entry {
  fill: var(--add-entry-fill-color);
  border-radius: 11px;
}

.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry {
  margin-right: 69px;
}

.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry:hover {
  margin-right: 19px;
}

.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry-label {
  display: none;
  color: var(--add-entry-label-color);
  padding: 0 6px 0 2px;
}

.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover {
  background-color: var(--add-entry-hover-background-color);
  fill: var(--add-entry-hover-fill-color);
}

.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover .bio-properties-panel-add-entry-label {
  display: block;
}

.bio-properties-panel-group-entries {
  display: none;
}

.bio-properties-panel-group-entries.open {
  display: block;
}

.bio-properties-panel-arrow {
  display: flex;
  justify-content: center;
  text-align: center;
  fill: var(--arrow-fill-color);
  min-width: 22px;
  border-radius: 11px;
  border: none;
  background: none;
}

.bio-properties-panel-arrow:hover {
  background-color: var(--arrow-hover-background-color);
}

.bio-properties-panel-arrow-down {
  transform: rotate(90deg);
}

.bio-properties-panel-dot {
  align-self: center;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  margin: 12px;
  background-color: var(--dot-color);
}

.bio-properties-panel-dot--error {
  --dot-color: var(--dot-color-error);
}

/**
 * Lists
 */
.bio-properties-panel-list {
  display: none;
}

.bio-properties-panel-list.open {
  display: block;
  margin-bottom: 6px;
  padding-bottom: 2px;
}

.bio-properties-panel-list-badge {
  height: 22px;
  min-width: 22px;
  color: var(--list-badge-color);
  border-radius: 11px;
  font-size: var(--text-size-small);
  line-height: 22px;
  text-align: center;
  user-select: none;
  padding: 0 5px;
  margin: 5px;
  background-color: var(--list-badge-background-color);
}

.bio-properties-panel-list-badge--error {
  --list-badge-background-color: var(--dot-color-error);
}

/**
 * Basic entries
 */
.bio-properties-panel-entry {
  margin: 2px 32px 6px 12px;
}

.bio-properties-panel-entry:last-child {
  padding-bottom: 10px;
}

.bio-properties-panel-label {
  display: block;
  font-size: var(--text-size-small);
  margin: 2px 0 1px;
}

.bio-properties-panel-description,
.bio-properties-panel-description p,
.bio-properties-panel-description span,
.bio-properties-panel-description div {
  color: var(--description-color);
  display: block;
  margin: 2px 0 4px;
  line-height: var(--line-height-condensed);
  font-weight: 400;
  font-size: var(--text-size-small);
}

.bio-properties-panel-description code {
  color: var(--description-color);
  font-family: var(--font-family);
  font-size: var(--text-size-small);
  line-height: var(--line-height-condensed);
  padding: 0 2px;
  background-color: var(--description-code-background-color);
  border: 1px solid var(--description-code-border-color);
  border-radius: 3px;
}

.bio-properties-panel-description pre code {
  width: 100%;
  display: block;
  overflow-x: auto;
  padding: 4px 6px;
  font-family: var(--font-family-monospace);
}

.bio-properties-panel-description ul {
  padding: 0;
  margin: 0 0 0 12px;
  list-style-type: disc;
}

.bio-properties-panel-description li {
  color: var(--description-list-item-color);
  margin: 0 0 0 12px;
}

.bio-properties-panel-description a {
  color: var(--link-color);
  font-size: var(--text-size-small);
  text-decoration: underline;
}

.bio-properties-panel-feelers-editor.bio-properties-panel-input {
  padding: 0;
}

.bio-properties-panel-feelers-input .cm-editor
{
  min-height: 32px;
  max-height: 215px;
  background-color: transparent;
}

.bio-properties-panel-feelers-editor .cm-editor.cm-focused,
.bio-properties-panel-feelers-input .cm-editor.cm-focused {
  outline: none;
}

.bio-properties-panel-input {
  padding: 3px 6px 2px;
  border: 1px solid var(--input-border-color);
  border-radius: 2px;
  background-color: var(--input-background-color);
  font-size: var(--text-size-base);
  font-family: inherit;
}

.bio-properties-panel-input[type=number],
select.bio-properties-panel-input,
textarea.bio-properties-panel-input,
.bio-properties-panel-input[type=text] {
  display: block;
  width: 100%;
}

textarea.bio-properties-panel-input {
  min-height: 28px;
}

.bio-properties-panel-input:focus,
.bio-properties-panel-input:focus-within {
  outline: none;
  background-color: var(--input-focus-background-color);
  border: 1px solid var(--input-focus-border-color);
}

.bio-properties-panel-textfield:focus-within,
.bio-properties-panel-feel-entry:focus-within {
  --input-background-color: var(--input-focus-background-color);
  --input-border-color: var(--input-focus-border-color);
}

.bio-properties-panel-input:disabled {
  border-color: var(--input-disabled-border-color);
  background-color: var(--input-disabled-background-color);
  color: var(--input-disabled-color);
}

select.bio-properties-panel-input {
  padding: 4px 6px;
}

.bio-properties-panel-input-monospace {
  font-family: var(--font-family-monospace);
}

.bio-properties-panel-input[type="checkbox"], .bio-properties-panel-input[type="radio"] {
  margin: 0;
  vertical-align: middle;
}

.bio-properties-panel-input[type="checkbox"]:focus {
  outline: 2px solid var(--input-focus-border-color);
  outline-offset: 0;
}

.bio-properties-panel-checkbox > .bio-properties-panel-label {
  display: inline-block;
  font-size: var(--text-size-base);
  margin-left: 6px;
  margin-top: auto;
  vertical-align: middle;
}

.bio-properties-panel-checkbox-entry + .bio-properties-panel-checkbox-entry  {
  margin-top: -8px;
}

.bio-properties-panel-checkbox-entry > .bio-properties-panel-description  {
  margin-left: 18px;
}

textarea.bio-properties-panel-input {
  resize: vertical;
}

.bio-properties-panel-entry.has-error .bio-properties-panel-input,
.bio-properties-panel-entry.has-error .bio-properties-panel-feel-editor__open-popup-placeholder {
  border-color: var(--input-error-border-color);
  background-color: var(--input-error-background-color);
}

.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator {
  border-color: var(--input-error-border-color);
}

.bio-properties-panel-entry.has-error .bio-properties-panel-input:focus,
.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator:focus {
  border-color: var(--input-error-focus-border-color);
}

.bio-properties-panel-entry .bio-properties-panel-error {
  color: var(--text-error-color);
  margin: 4px 0;
  font-size: var(--text-size-small);
}

.bio-properties-panel-simple {
  width: 100%;
  margin-right: 8px;
}

.bio-properties-panel-simple + .bio-properties-panel-remove-entry {
  margin: auto;
}

/**
 * Toggle Switch
 */
.bio-properties-panel-toggle-switch-entry + .bio-properties-panel-toggle-switch-entry  {
  margin-top: -8px;
}

.bio-properties-panel-toggle-switch-entry > .bio-properties-panel-description {
  margin-left: 38px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-field-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bio-properties-panel-toggle-switch.inline {
  display: flex;
  flex-direction: row;
}

.bio-properties-panel-toggle-switch.inline .bio-properties-panel-field-wrapper {
  margin-left: auto;
}

.bio-properties-panel-toggle-switch > .bio-properties-panel-label {
  font-size: var(--text-size-base);
}

.bio-properties-panel-toggle-switch.inline > .bio-properties-panel-label {
  font-size: var(--text-size-small);
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__label {
  margin: 0;
  margin-left: 6px;
  font-size: var(--text-size-base);
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher {
  position: relative;
  width: 32px;
  height: 16px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher:focus-within {
  outline: 2px solid var(--input-focus-border-color);
  outline-offset: 1px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type='checkbox'] {
  opacity: 0;
  width: 0;
  height: 0;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--toggle-switch-off-background-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2px;
  background-color: var(--toggle-switch-switcher-background-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type='checkbox']:checked + .bio-properties-panel-toggle-switch__slider {
  background-color: var(--toggle-switch-on-background-color);
  box-shadow: 0 0 1px ;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type='checkbox']:checked + .bio-properties-panel-toggle-switch__slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/**
 * Collapsible entries
 */
.bio-properties-panel-collapsible-entry-entries {
  position: relative;
  display: none;
}

.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child {
  padding-bottom: 0;
}

.bio-properties-panel-collapsible-entry-entries.open {
  display: block;
}

.bio-properties-panel-collapsible-entry-entries  {
  padding-left: 20px;
  margin-bottom: 10px;
  position: relative;
  display: none;
}

.bio-properties-panel-collapsible-entry-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

.bio-properties-panel-collapsible-entry-header .bio-properties-panel-collapsible-entry-header-title {
  padding: 2px 24px 2px 32px;
  font-size: var(--text-size-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.bio-properties-panel-collapsible-entry-arrow {
  position: absolute;
  top: 2px;
  left: 6px;
  padding: 0 3px;
  height: 22px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.bio-properties-panel-remove-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  padding: 0;
  width: 22px;
  height: 22px;
  fill: var(--remove-entry-fill-color);
  border-radius: 50%;
  border: none;
  background: none;
  visibility: hidden;
}

.bio-properties-panel-remove-entry:hover {
  background-color: var(--remove-entry-hover-background-color);
}

.bio-properties-panel-list-entry-item:hover .bio-properties-panel-remove-list-entry,
.bio-properties-panel-collapsible-entry:hover > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry,
.bio-properties-panel-collapsible-entry:focus-within > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry
{
  visibility: visible;
}

/* Side line */
.bio-properties-panel-collapsible-entry-entries::before {
  content: "";
  position: absolute;
  left: 16px;
  width: 2px;
  top: -6px;
  bottom: 12px;
  background-color: var(--side-line-background-color);
  border-radius: 1px;
}

/* Side line extension for non-list entry or open list entry positioned as the last one. */
.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child,
.bio-properties-panel-list-entry.open:last-child {
  position: relative;
}

.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child::after,
.bio-properties-panel-list-entry.open:last-child::after {
  content: "";
  position: absolute;
  left: -16px;
  width: 2px;
  top: 0;
  bottom: -4px;
  background-color: var(--side-line-extension-background-color);
  border-radius: 1px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child::after {
  left: -18px;
}

/*
 * List entry
 */
.bio-properties-panel-list-entry {
  position: relative;
  margin-right: 5px;
  margin-bottom: 0;
}

.bio-properties-panel-list-entry .bio-properties-panel-entry {
  margin-right: 0;
}

.bio-properties-panel-list-entry-header {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  height: 32px;
}

/* Nested list dot */
.bio-properties-panel-list-entry::before {
  content: "";
  width: 8px;
  height: 8px;
  position: absolute;
  left: -19px;
  top: 13px;
  border-radius: 50%;
  background-color: var(--list-entry-dot-background-color);
}

.bio-properties-panel-list-entry-header-title {
  display: block;
  margin: auto 0;
  padding: 2px 0;
  font-size: var(--text-size-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bio-properties-panel-list-entry-header-title.open {
  font-weight: 500;
}

.bio-properties-panel-list-entry-header-buttons {
  display: flex;
  align-items: center;
}

.bio-properties-panel-list-entry-header-buttons > button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 22px;
  line-height: 22px;
  min-width: 22px;
  margin: 5px;
  padding: 0 3px;
  border: none;
  background: none;
  fill: var(--list-entry-header-button-fill-color);
}

.bio-properties-panel-list-entry-header-buttons > :last-child {
  margin-right: 0;
}

.bio-properties-panel-list-entry-items {
  padding: 0;
  margin: 0;

  list-style: none;
}

.bio-properties-panel-list-entry-items:not(.open) {
  display: none;
}

.bio-properties-panel-list-entry-item {
  display: flex;
  justify-content: space-between;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-remove-entry {
  margin-right: 1px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry {
  width: 100%;
  margin-right: 4px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header {
  margin-left: -8px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-arrow {
  left: 2px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header-title {
  padding-left: 30px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries {
  padding-left: 10px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries::before {
  left: 4px;
}

.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry {
  margin-right: 16px;
  padding-left: 6px;
}

.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry-label {
  color: var(--list-entry-add-entry-label-color);
  padding: 4px 6px 3px 2px;
}

.bio-properties-panel-list-entry-header-buttons .bio-properties-panel-add-entry:hover {
  background-color: var(--list-entry-add-entry-background-color);
  fill: var(--list-entry-add-entry-fill-color);
}

.bio-properties-panel-list-entry-item .bio-properties-panel-simple .bio-properties-panel-input {
  border-radius: 0;
  margin-bottom: -2px;
}

.bio-properties-panel-list-entry-item:first-child .bio-properties-panel-simple .bio-properties-panel-input {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.bio-properties-panel-list-entry-item:last-child .bio-properties-panel-simple .bio-properties-panel-input {
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.bio-properties-panel-dropdown-button {
  position: relative;

  --dropdown-button-margin: 5px;
}

.bio-properties-panel-dropdown-button:not(.open) .bio-properties-panel-dropdown-button__menu {
  display: none;
}

.bio-properties-panel-dropdown-button__menu {
  min-width: calc(100% - var(--dropdown-button-margin) * 2);
  max-width: 240px;

  position: absolute;
  top: calc(100% - var(--dropdown-button-margin));
  right: var(--dropdown-button-margin);
  z-index: 101;

  background-color: var(--dropdown-item-background-color);

  padding: 8px 0;

  box-shadow: 0 1px 4px 0 var(--color-grey-225-10-85), 0 2px 16px 0 var(--color-grey-225-10-75)
}

.bio-properties-panel-dropdown-button__menu-item {
  display: block;
  width: 100%;
  padding: 4px 12px;

  font-size: var(--text-size-small);
  appearance: revert;
  border: unset;
  background: unset;
  text-align: unset;
}

.bio-properties-panel-dropdown-button__menu-item--separator {
  width: 100%;
  height: 1px;

  padding: 0;
  margin: 8px 0;

  background-color: var(--dropdown-separator-background-color);
}

.bio-properties-panel-dropdown-button__menu-item--actionable {
  font-size: var(--text-size-base);
}

.bio-properties-panel-dropdown-button__menu-item--actionable:hover {
  background-color: var(--dropdown-item-hover-background-color);
}

.bio-properties-panel-feel-input {
  position: relative;
}

.bio-properties-panel-feel-input input {
  padding-right: 2em
}

.bio-properties-panel-feel-entry .bio-properties-panel-label {
  display: flex;
}

.bio-properties-panel-feel-icon {
  display: inline-flex;
  height: 18px;
  width: 22px;
  vertical-align: text-bottom;
  padding: 0;
  margin: 0 3px;
  align-items: center;
  align-self: center;
  justify-content: center;
  border: none;
  background: none;
  border-radius: 3px;
}

.bio-properties-panel-feel-icon.optional {
  cursor: pointer;
  background: var(--feel-background-color);
}

.bio-properties-panel-feel-icon svg * {
  fill: var(--feel-inactive-color);
}

.bio-properties-panel-feel-icon:hover {
  background: var(--feel-hover-background-color);
}

.bio-properties-panel-feel-icon:hover svg * {
  fill: var(--feel-hover-color);
}

.bio-properties-panel-feel-icon.active {
  background: var(--feel-active-background-color);
}

.bio-properties-panel-feel-icon.active:hover {
  background: var(--feel-hover-background-color);
}

.bio-properties-panel-feel-icon.required.active {
  background: none;
}

.bio-properties-panel-feel-icon.active svg * {
  fill: var(--feel-active-color);
}

.bio-properties-panel-feel-icon.required.active svg * {
  fill: var(--feel-required-color);
}

.bio-properties-panel-feel-editor-container {
  position: relative;
}

.bio-properties-panel-feel-editor-container.active {
  font-family: var(--font-family-monospace);
}

.bio-properties-panel-feel-container {
  position: relative;
}

.bio-properties-panel-feel-container .bio-properties-panel-feel-editor-container>div {
  position: static;
  padding-left: 2.4em !important;
  min-height: 28px;
}

.bio-properties-panel-feel-indicator {
  position: absolute;
  border: 1px solid var(--input-border-color);
  background-color: var(--feel-indicator-background-color);
  border-right: 0px;
  border-radius: 2px 0 0 2px;
  z-index: 1;
  height: 100%;
  width: 2em;
  text-align: center;
  padding: 2px 6px;
}

.bio-properties-panel-feel-editor-container .cm-scroller {
  overflow: hidden !important;
}

.bio-properties-panel-feelers-editor .cm-editor {
  background-color: transparent;
}


/* @Note(pinussilvestrus): mitigate low contrast - https://github.com/bpmn-io/cm-theme/issues/4 */
.bio-properties-panel-feelers-editor .cm-content ::selection {
  background: var(--feelers-select-color, hsl(205, 100%, 85%));
}

.bio-properties-panel-feelers-editor .cm-editor.cm-focused {
  background-color: transparent;
}

.bio-properties-panel-feel-editor-container .bio-properties-panel-input {
  resize: none;
  overflow: hidden;
  overflow-y: auto;
}

.bio-properties-panel-feel-editor-container,
.bio-properties-panel-feel-editor-container .bio-properties-panel-input,
.bio-properties-panel-feel-container .cm-editor {
  min-height: 100%;
}

.bio-properties-panel-feel-checkbox,
.bio-properties-panel-feel-toggle-switch {
  padding-top: 1px;
}

.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active),
.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container,
.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container {
  margin-left: auto;
}

.bio-properties-panel-tooltip-wrapper {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  font: inherit;
  display: flex;
  justify-content: center;
  width: fit-content;
}

.bio-properties-panel-tooltip {
  --tooltip-underline-color: var(--color-blue-219-99-53);
  --tooltip-background-color: var(--color-grey-0-0-22);
  --tooltip-link: var(--color-blue-218-100-74);
  --tooltip-code-background-color: var(--color-grey-225-10-97);
  --tooltip-code-border-color: var(--color-grey-225-10-85);

  display: flex;
  color: var(--color-white, white);
  position: fixed;
  z-index: 1000;
  max-width: 300px;
  font-size: var(--text-size-small);
  font-family: var(--font-family);
}

.bio-properties-panel-tooltip.right {
  padding-right: 6px;
}

.bio-properties-panel-tooltip.top {
  flex-direction: column;
}

.bio-properties-panel-tooltip-content {
  background-color: var(--tooltip-background-color);
  padding: 16px;
  border-radius: 2px;
  font-weight: 400;
  white-space: pre-wrap;
}

.bio-properties-panel-tooltip-content h1 {
  font-size: var(--text-size-base);
  font-weight: bold;
  margin: 0;
}

.bio-properties-panel-tooltip-content code,
.bio-properties-panel-tooltip-content pre {
  color: var(--description-color);
  font-family: var(--font-family);
  font-size: var(--text-size-small);
  line-height: var(--line-height-condensed);
  padding: 0 2px;
  background-color: var(--tooltip-code-background-color);
  border: 1px solid var(--tooltip-code-border-color);
  border-radius: 3px;
}

.bio-properties-panel-tooltip-content pre code {
  border: none;
}

.bio-properties-panel-tooltip p:first-child {
  margin-top: 0;
}

.bio-properties-panel-tooltip p:last-child {
  margin-bottom: 0;
}

.bio-properties-panel-tooltip-content a {
  color: var(--tooltip-link);
}

.bio-properties-panel-tooltip .bio-properties-panel-tooltip-arrow {
  width: 0; 
  height: 0; 
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid var(--tooltip-background-color);
  margin-top: 16px;
}

.bio-properties-panel-tooltip.top .bio-properties-panel-tooltip-arrow {
  margin-top: -3px;
  margin-left: calc(50% - 2.5px);
  transform: rotate(90deg);
}

.bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor__open-popup-placeholder,
.bio-properties-panel-feel-editor-container .bio-properties-panel-feel-editor__open-popup-placeholder {
  display: none;
  justify-content: center;
  flex-direction: column;
  color: hsla(0, 0%, 9%, 0.25);
  padding: 3px 6px 2px;
  border: 1px solid var(--input-border-color);
  border-radius: 2px;
  background-color: var(--input-background-color);
  font-size: var(--text-size-base);
  font-family: inherit;
  width: 100%;
  min-height: 100%;
}

.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-input,
.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-input {
  display: none;
}

.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-feelers-editor__open-popup-placeholder,
.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-feel-editor__open-popup-placeholder {
  display: flex;
}

.bio-properties-panel-popup {
  --popup-background-color: hsla(0, 0%, 96%, 1);
  --popup-header-background-color: white;
  --popup-font-color: hsla(0, 0%, 0%, 1);
  --popup-title-color: hsla(0, 0%, 0%, 1);

  --feel-popup-close-background-color: hsla(219, 99%, 53%, 1);
  --feel-popup-gutters-background-color: hsla(0, 0%, 90%, 1);

  position: fixed;
  display: flex;
  flex: auto;
  flex-direction: column;
  font-family: IBM Plex Sans, sans-serif;
  padding: 0;
  z-index: 1001;
  box-shadow: 0px 2px 6px 0px hsla(0, 0%, 0%, 0.3);
  background-color: var(--popup-background-color);
  color: var(--popup-font-color);
  height: auto;
  width: auto;
  overflow: hidden;
  font-size: 14px;
}

.bio-properties-panel-popup h1, 
.bio-properties-panel-popup h2, 
.bio-properties-panel-popup h3, 
.bio-properties-panel-popup h4 {
  font-weight: 500;
  font-size: inherit;
}

.bio-properties-panel-popup .bio-properties-panel-popup__header,
.bio-properties-panel-popup .bio-properties-panel-popup__body,
.bio-properties-panel-popup .bio-properties-panel-popup__footer {
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bio-properties-panel-popup .bio-properties-panel-popup__body:not(:first-child) {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}

.bio-properties-panel-popup .bio-properties-panel-popup__header {
  --popup-header-line-height: 16px;
  background-color: var(--popup-header-background-color);
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: var(--popup-header-line-height);
  text-align: left;
  color: var(--popup-title-color);
}

.bio-properties-panel-popup .bio-properties-panel-popup__header.draggable {
  cursor: grab;
}

.bio-properties-panel-popup .bio-properties-panel-popup__drag-handle {
  display: flex;
}

.bio-properties-panel-popup .bio-properties-panel-popup__drag-preview {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
}

.bio-properties-panel-popup .bio-properties-panel-popup__title {
  margin-left: 8px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__title::first-letter {
  text-transform: capitalize;
}

.bio-properties-panel-popup .bio-properties-panel-popup__close {
  margin: -12px;
  margin-left: 12px;
  width: 40px;
  height: 40px;
  border: none;
  background-color: var(--popup-header-background-color);
}

.bio-properties-panel-popup .bio-properties-panel-popup__close:hover,
.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {
  background-color: var(--popup-background-color);
}

.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {
  outline-offset: -2px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__close svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
  margin-top: 2px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__header .bio-properties-panel-popup__drag-handle svg {
  margin-left: -4px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__body {
  font-size: inherit;
  height: 100%;
  display: flex;
  overflow: auto;
  padding-bottom: 0;
}

.bio-properties-panel-popup .bio-properties-panel-popup__footer {
  position: absolute;
  bottom: 0;
  right: 8px;
}

.bio-properties-panel-feel-popup {
  min-height: 400px;
  width: fit-content;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-popup__body {
  display: flex;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.bio-properties-panel-feel-popup__title-link {
  margin-left: 8px; 
  display: flex;
}

.bio-properties-panel-feel-popup__title-link:first-of-type {
  margin-left: auto;
}

.bio-properties-panel-feel-popup__title-link svg {
  width: var(--popup-header-line-height);
  height: var(--popup-header-line-height);
  fill: currentColor;
  margin: 0 0.5em;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container {
  display: flex;
  min-width: 100%;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-scroller {
  overflow: auto !important;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container {
  width: 100%;
  display: flex;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor {
  display: flex;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor .cm-editor {
  width: 100%;
}

.bio-properties-panel-feel-popup .bio-properties-panel-input {
  width: 100%;
  resize: none;
  padding: 0;
  overflow: hidden;
  overflow-y: auto
}

.bio-properties-panel-feel-popup .bio-properties-panel-open-feel-popup {
  display: none !important;
}

.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 1;
  padding: 2px 4px;
  margin: 3px;
  display: none;
  background: none;
  border: none;
  color: var(--feel-open-popup-color);
  cursor: pointer;
}

.bio-properties-panel-feelers-editor-container:hover .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feel-container:hover .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feelers-editor-container:focus-within .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feel-container:focus-within .bio-properties-panel-open-feel-popup {
  display: block;
}

.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup:hover,
.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup:hover {
  color: var(--feel-open-popup-hover-color);
}

.bio-properties-panel-feel-popup .bio-properties-panel-popup__footer .bio-properties-panel-feel-popup__close-btn {
  background: var(--feel-popup-close-background-color);
  width: 66px;
  font-weight: 400;
  font-size: 14px;
  font-family: inherit;
  color: white;
  border: none;
  height: 32px;
  cursor: pointer;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor {
  width: 100%;
  height: 100%;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor .cm-content {
  padding-left: 4px;
}

.bio-properties-panel-feel-popup .cm-gutters {
  background-color: var(--feel-popup-gutters-background-color);
  border: none;
  padding: 0;
}

.bio-properties-panel-feel-popup .cm-gutter {
  min-width: 32px;
}

.bio-properties-panel-feel-popup .cm-gutters .cm-lineNumbers .cm-gutterElement {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./node_modules/dmn-js-properties-panel/dist/assets/properties-panel.css"],"names":[],"mappings":"AAAA;;EAEE;CACD;;EAEC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,oCAAoC;;EAEpC,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,0CAA0C;EAC1C,4CAA4C;EAC5C,2CAA2C;;EAE3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;;AAElC;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,0CAA0C;;EAE1C,gDAAgD;EAChD,gEAAgE;EAChE,4DAA4D;EAC5D,0DAA0D;;EAE1D,gDAAgD;EAChD,2DAA2D;;EAE3D,sDAAsD;EACtD,qDAAqD;EACrD,yDAAyD;;EAEzD,4CAA4C;EAC5C,wDAAwD;;EAExD,4DAA4D;EAC5D,+DAA+D;;EAE/D,mDAAmD;EACnD,gDAAgD;EAChD,gEAAgE;EAChE,2CAA2C;;EAE3C,sDAAsD;EACtD,kEAAkE;;EAElE,+CAA+C;EAC/C,2DAA2D;;EAE3D,wCAAwC;EACxC,8CAA8C;;EAE9C,sCAAsC;EACtC,0DAA0D;;EAE1D,qDAAqD;EACrD,iDAAiD;;EAEjD,4DAA4D;EAC5D,wDAAwD;;EAExD,2DAA2D;EAC3D,uDAAuD;EACvD,6DAA6D;;EAE7D,mDAAmD;EACnD,8DAA8D;EAC9D,0DAA0D;;EAE1D,iEAAiE;EACjE,iEAAiE;EACjE,6DAA6D;;EAE7D,yDAAyD;EACzD,mEAAmE;;EAEnE,8DAA8D;EAC9D,kEAAkE;EAClE,2EAA2E;EAC3E,iFAAiF;EACjF,sDAAsD;EACtD,qEAAqE;EACrE,qDAAqD;;EAErD,oDAAoD;EACpD,mEAAmE;EACnE,kEAAkE;;EAElE,oCAAoC;EACpC,iDAAiD;EACjD,kDAAkD;EAClD,+CAA+C;EAC/C,0DAA0D;EAC1D,2CAA2C;EAC3C,kDAAkD;EAClD,4CAA4C;EAC5C,sDAAsD;EACtD,qDAAqD;;EAErD,8DAA8D;;EAE9D,qDAAqD;;EAErD,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,6BAA6B;;EAE7B,yBAAyB;EACzB,kCAAkC;;EAElC,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gDAAgD;EAChD,0DAA0D;EAC1D,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA;;EAEE;AACF;EACE,+CAA+C;EAC/C,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB,EAAE,yBAAyB;EAC9C,kBAAkB,GAAG,mCAAmC;EACxD,wBAAwB,GAAG,eAAe;EAC1C,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,gEAAgE;AAClE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,yDAAyD;EACzD,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE;AACF;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE;AACF;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;;;EAIE,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,yCAAyC;EACzC,cAAc;EACd,0DAA0D;EAC1D,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;;;EAIE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;;EAEE,6DAA6D;EAC7D,qDAAqD;AACvD;;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2DAA2D;EAC3D,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,gEAAgE;EAChE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,YAAY;EACZ,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA,0FAA0F;AAC1F;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,MAAM;EACN,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;;EAET,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA;EACE,8DAA8D;EAC9D,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;;EAElB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;;EAEhB,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,YAAY;;EAEZ,uDAAuD;;EAEvD,cAAc;;EAEd;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;;EAEjB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;;EAEX,UAAU;EACV,aAAa;;EAEb,4DAA4D;AAC9D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,wDAAwD;EACxD,iBAAiB;EACjB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA,iGAAiG;AACjG;EACE,4DAA4D;AAC9D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,oDAAoD;EACpD,4CAA4C;EAC5C,4DAA4D;EAC5D,wDAAwD;;EAExD,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,yCAAyC;EACzC,cAAc;EACd,sDAAsD;EACtD,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;EAChC,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,sCAAsC;EACtC,uCAAuC;;EAEvC,2DAA2D;EAC3D,0DAA0D;;EAE1D,eAAe;EACf,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,sCAAsC;EACtC,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,+CAA+C;EAC/C,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;EACtD,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sDAAsD;AACxD;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;EACpD,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/**\r\n * Theming\r\n */\r\n .bio-properties-panel,\r\n .djs-parent {\r\n  --color-grey-225-10-15: hsl(225, 10%, 15%);\r\n  --color-grey-225-10-35: hsl(225, 10%, 35%);\r\n  --color-grey-225-10-55: hsl(225, 10%, 55%);\r\n  --color-grey-225-10-75: hsl(225, 10%, 75%);\r\n  --color-grey-225-10-80: hsl(225, 10%, 80%);\r\n  --color-grey-225-10-85: hsl(225, 10%, 85%);\r\n  --color-grey-225-10-90: hsl(225, 10%, 90%);\r\n  --color-grey-225-10-95: hsl(225, 10%, 95%);\r\n  --color-grey-225-10-97: hsl(225, 10%, 97%);\r\n  --color-grey-0-0-22: hsl(0, 0%, 22%);\r\n\r\n  --color-blue-205-100-35: hsl(205, 100%, 35%);\r\n  --color-blue-205-100-45: hsl(205, 100%, 45%);\r\n  --color-blue-205-100-50: hsl(205, 100%, 50%);\r\n  --color-blue-205-100-85: hsl(205, 100%, 85%);\r\n  --color-blue-205-100-95: hsl(205, 100%, 95%);\r\n  --color-blue-219-99-53: hsl(219, 99%, 53%);\r\n  --color-blue-218-100-74: hsl(218, 100%, 74%);\r\n  --color-green-150-86-44: hsl(150, 86%, 44%);\r\n\r\n  --color-red-360-100-40: hsl(360, 100%, 40%);\r\n  --color-red-360-100-45: hsl(360, 100%, 45%);\r\n  --color-red-360-100-92: hsl(360, 100%, 92%);\r\n  --color-red-360-100-97: hsl(360, 100%, 97%);\r\n  --color-white: white;\r\n  --color-black: black;\r\n  --color-transparent: transparent;\r\n\r\n}\r\n\r\n.bio-properties-panel {\r\n  --text-base-color: var(--color-grey-225-10-15);\r\n  --text-error-color: var(--color-red-360-100-45);\r\n  --link-color: var(--color-blue-205-100-50);\r\n\r\n  --description-color: var(--color-grey-225-10-35);\r\n  --description-code-background-color: var(--color-grey-225-10-97);\r\n  --description-code-border-color: var(--color-grey-225-10-85);\r\n  --description-list-item-color: var(--color-grey-225-10-35);\r\n\r\n  --placeholder-color: var(--color-grey-225-10-35);\r\n  --placeholder-background-color: var(--color-grey-225-10-95);\r\n\r\n  --header-background-color: var(--color-grey-225-10-95);\r\n  --header-icon-fill-color: var(--color-grey-225-10-15);\r\n  --header-bottom-border-color: var(--color-grey-225-10-75);\r\n\r\n  --group-background-color: var(--color-white);\r\n  --group-bottom-border-color: var(--color-grey-225-10-75);\r\n\r\n  --sticky-group-background-color: var(--color-grey-225-10-95);\r\n  --sticky-group-bottom-border-color: var(--color-grey-225-10-75);\r\n\r\n  --add-entry-fill-color: var(--color-grey-225-10-35);\r\n  --add-entry-hover-fill-color: var(--color-white);\r\n  --add-entry-hover-background-color: var(--color-blue-205-100-50);\r\n  --add-entry-label-color: var(--color-white);\r\n\r\n  --remove-entry-fill-color: var(--color-red-360-100-45);\r\n  --remove-entry-hover-background-color: var(--color-red-360-100-92);\r\n\r\n  --arrow-fill-color: var(--color-grey-225-10-35);\r\n  --arrow-hover-background-color: var(--color-grey-225-10-95);\r\n\r\n  --dot-color: var(--color-grey-225-10-35);\r\n  --dot-color-error: var(--color-red-360-100-45);\r\n\r\n  --list-badge-color: var(--color-white);\r\n  --list-badge-background-color: var(--color-grey-225-10-35);\r\n\r\n  --input-background-color: var(--color-grey-225-10-97);\r\n  --input-border-color: var(--color-grey-225-10-75);\r\n\r\n  --input-focus-background-color: var(--color-blue-205-100-95);\r\n  --input-focus-border-color: var(--color-blue-205-100-50);\r\n\r\n  --input-error-background-color: var(--color-red-360-100-97);\r\n  --input-error-border-color: var(--color-red-360-100-45);\r\n  --input-error-focus-border-color: var(--color-red-360-100-45);\r\n\r\n  --input-disabled-color: var(--color-grey-225-10-55);\r\n  --input-disabled-background-color: var(--color-grey-225-10-97);\r\n  --input-disabled-border-color: var(--color-grey-225-10-90);\r\n\r\n  --toggle-switch-on-background-color: var(--color-blue-205-100-50);\r\n  --toggle-switch-off-background-color: var(--color-grey-225-10-75);\r\n  --toggle-switch-switcher-background-color: var(--color-white);\r\n\r\n  --side-line-background-color: var(--color-grey-225-10-35);\r\n  --side-line-extension-background-color: var(--color-grey-225-10-35);\r\n\r\n  --list-entry-dot-background-color: var(--color-grey-225-10-35);\r\n  --list-entry-header-button-fill-color: var(--color-grey-225-10-35);\r\n  --list-entry-add-entry-empty-background-color: var(--color-blue-205-100-50);\r\n  --list-entry-add-entry-empty-hover-background-color: var(--color-blue-205-100-45);\r\n  --list-entry-add-entry-label-color: var(--color-white);\r\n  --list-entry-add-entry-background-color: var(--color-blue-205-100-50);\r\n  --list-entry-add-entry-fill-color: var(--color-white);\r\n\r\n  --dropdown-item-background-color: var(--color-white);\r\n  --dropdown-item-hover-background-color: var(--color-grey-225-10-95);\r\n  --dropdown-separator-background-color: var(--color-grey-225-10-75);\r\n\r\n  --feel-background-color: transparent;\r\n  --feel-active-color: var(--color-blue-205-100-45);\r\n  --feel-inactive-color: var(--color-grey-225-10-35);\r\n  --feel-hover-color: var(--color-grey-225-10-15);\r\n  --feel-hover-background-color: var(--color-grey-225-10-97);\r\n  --feel-active-background-color: transparent;\r\n  --feel-required-color: var(--color-grey-225-10-55);\r\n  --feel-open-popup-color: hsla(0, 0%, 32%, 1);\r\n  --feel-open-popup-background-color: var(--color-white);\r\n  --feel-open-popup-hover-color: hsla(219, 99%, 53%, 1);\r\n\r\n  --feel-indicator-background-color: var(--color-grey-225-10-90);\r\n\r\n  --feelers-select-color:  var(--color-blue-205-100-85);\r\n\r\n  --text-size-base: 14px;\r\n  --text-size-small: 13px;\r\n  --text-size-smallest: 12px;\r\n  --text-line-height: 21px;\r\n  --line-height-condensed: 17px;\r\n\r\n  --font-family: sans-serif;\r\n  --font-family-monospace: monospace;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.bio-properties-panel {\r\n  color: var(--text-base-color);\r\n}\r\n\r\n.bio-properties-panel * {\r\n  font-size: var(--text-size-base);\r\n  line-height: var(--text-line-height);\r\n  font-weight: 400;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.bio-properties-panel {\r\n  font-family: var(--font-family);\r\n}\r\n\r\n/**\r\n * Placeholder (empty, multi select, ...)\r\n */\r\n.bio-properties-panel-placeholder {\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  background-color: var(--placeholder-background-color);\r\n}\r\n\r\n.bio-properties-panel-placeholder-text {\r\n  color: var(--placeholder-color);\r\n  font-size: var(--text-size-base);\r\n  text-align: center;\r\n  margin: 12px 48px;\r\n}\r\n\r\n/**\r\n * Header\r\n */\r\n.bio-properties-panel-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  font-size: var(--text-size-base);\r\n  padding: 16px 10px;\r\n  background-color: var(--header-background-color);\r\n  border-bottom: 1px solid var(--header-bottom-border-color);\r\n  width: 100%;\r\n  z-index: 10;\r\n  max-height: 64px;\r\n  overflow: hidden;\r\n}\r\n\r\n.bio-properties-panel-header-icon {\r\n  fill: var(--header-icon-fill-color);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.bio-properties-panel-header-labels {\r\n  overflow: hidden;\r\n  margin-left: 12px;\r\n  user-select: none;\r\n}\r\n\r\n.bio-properties-panel-header-type {\r\n  font-size: var(--text-size-smallest);\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.bio-properties-panel-header-label {\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  margin-top: -6px;\r\n}\r\n\r\n.bio-properties-panel-header-actions {\r\n  margin-left: auto;\r\n  margin-top: auto;\r\n}\r\n\r\n/**\r\n * Scroll container\r\n */\r\n.bio-properties-panel-scroll-container {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  flex: 1;\r\n}\r\n\r\n/**\r\n * Groups\r\n */\r\n.bio-properties-panel-group {\r\n  background-color: var(--group-background-color);\r\n  border-bottom: 1px solid var(--group-bottom-border-color);\r\n  position: relative;\r\n}\r\n\r\n.bio-properties-panel-group-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  font-size: var(--text-size-base);\r\n  height: 32px;\r\n  user-select: none;\r\n  justify-content: space-between;\r\n  margin-bottom: -1px; /* avoid double borders */\r\n  position: relative;  /* browsers not supporting sticky */\r\n  position: -webkit-sticky;  /* for safari */\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.bio-properties-panel-group-header .bio-properties-panel-group-header-title {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin: 1px 12px 0;\r\n}\r\n\r\n.bio-properties-panel-group-header.open .bio-properties-panel-group-header-title {\r\n  font-weight: 500;\r\n}\r\n\r\n.bio-properties-panel-group-header.sticky {\r\n  background-color: var(--sticky-group-background-color);\r\n  border-bottom: 1px solid var(--sticky-group-bottom-border-color);\r\n}\r\n\r\n.bio-properties-panel-group-header-buttons {\r\n  display: flex;\r\n}\r\n\r\n.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-button {\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  align-self: center;\r\n  height: 22px;\r\n  line-height: 22px;\r\n  min-width: 22px;\r\n  margin: 5px;\r\n  padding: 0 3px;\r\n  border: none;\r\n  background: none;\r\n}\r\n\r\n.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-buttons:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.bio-properties-panel-add-entry {\r\n  fill: var(--add-entry-fill-color);\r\n  border-radius: 11px;\r\n}\r\n\r\n.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry {\r\n  margin-right: 69px;\r\n}\r\n\r\n.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry:hover {\r\n  margin-right: 19px;\r\n}\r\n\r\n.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry-label {\r\n  display: none;\r\n  color: var(--add-entry-label-color);\r\n  padding: 0 6px 0 2px;\r\n}\r\n\r\n.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover {\r\n  background-color: var(--add-entry-hover-background-color);\r\n  fill: var(--add-entry-hover-fill-color);\r\n}\r\n\r\n.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover .bio-properties-panel-add-entry-label {\r\n  display: block;\r\n}\r\n\r\n.bio-properties-panel-group-entries {\r\n  display: none;\r\n}\r\n\r\n.bio-properties-panel-group-entries.open {\r\n  display: block;\r\n}\r\n\r\n.bio-properties-panel-arrow {\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  fill: var(--arrow-fill-color);\r\n  min-width: 22px;\r\n  border-radius: 11px;\r\n  border: none;\r\n  background: none;\r\n}\r\n\r\n.bio-properties-panel-arrow:hover {\r\n  background-color: var(--arrow-hover-background-color);\r\n}\r\n\r\n.bio-properties-panel-arrow-down {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.bio-properties-panel-dot {\r\n  align-self: center;\r\n  height: 8px;\r\n  min-width: 8px;\r\n  border-radius: 50%;\r\n  margin: 12px;\r\n  background-color: var(--dot-color);\r\n}\r\n\r\n.bio-properties-panel-dot--error {\r\n  --dot-color: var(--dot-color-error);\r\n}\r\n\r\n/**\r\n * Lists\r\n */\r\n.bio-properties-panel-list {\r\n  display: none;\r\n}\r\n\r\n.bio-properties-panel-list.open {\r\n  display: block;\r\n  margin-bottom: 6px;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.bio-properties-panel-list-badge {\r\n  height: 22px;\r\n  min-width: 22px;\r\n  color: var(--list-badge-color);\r\n  border-radius: 11px;\r\n  font-size: var(--text-size-small);\r\n  line-height: 22px;\r\n  text-align: center;\r\n  user-select: none;\r\n  padding: 0 5px;\r\n  margin: 5px;\r\n  background-color: var(--list-badge-background-color);\r\n}\r\n\r\n.bio-properties-panel-list-badge--error {\r\n  --list-badge-background-color: var(--dot-color-error);\r\n}\r\n\r\n/**\r\n * Basic entries\r\n */\r\n.bio-properties-panel-entry {\r\n  margin: 2px 32px 6px 12px;\r\n}\r\n\r\n.bio-properties-panel-entry:last-child {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.bio-properties-panel-label {\r\n  display: block;\r\n  font-size: var(--text-size-small);\r\n  margin: 2px 0 1px;\r\n}\r\n\r\n.bio-properties-panel-description,\r\n.bio-properties-panel-description p,\r\n.bio-properties-panel-description span,\r\n.bio-properties-panel-description div {\r\n  color: var(--description-color);\r\n  display: block;\r\n  margin: 2px 0 4px;\r\n  line-height: var(--line-height-condensed);\r\n  font-weight: 400;\r\n  font-size: var(--text-size-small);\r\n}\r\n\r\n.bio-properties-panel-description code {\r\n  color: var(--description-color);\r\n  font-family: var(--font-family);\r\n  font-size: var(--text-size-small);\r\n  line-height: var(--line-height-condensed);\r\n  padding: 0 2px;\r\n  background-color: var(--description-code-background-color);\r\n  border: 1px solid var(--description-code-border-color);\r\n  border-radius: 3px;\r\n}\r\n\r\n.bio-properties-panel-description pre code {\r\n  width: 100%;\r\n  display: block;\r\n  overflow-x: auto;\r\n  padding: 4px 6px;\r\n  font-family: var(--font-family-monospace);\r\n}\r\n\r\n.bio-properties-panel-description ul {\r\n  padding: 0;\r\n  margin: 0 0 0 12px;\r\n  list-style-type: disc;\r\n}\r\n\r\n.bio-properties-panel-description li {\r\n  color: var(--description-list-item-color);\r\n  margin: 0 0 0 12px;\r\n}\r\n\r\n.bio-properties-panel-description a {\r\n  color: var(--link-color);\r\n  font-size: var(--text-size-small);\r\n  text-decoration: underline;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor.bio-properties-panel-input {\r\n  padding: 0;\r\n}\r\n\r\n.bio-properties-panel-feelers-input .cm-editor\r\n{\r\n  min-height: 32px;\r\n  max-height: 215px;\r\n  background-color: transparent;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor .cm-editor.cm-focused,\r\n.bio-properties-panel-feelers-input .cm-editor.cm-focused {\r\n  outline: none;\r\n}\r\n\r\n.bio-properties-panel-input {\r\n  padding: 3px 6px 2px;\r\n  border: 1px solid var(--input-border-color);\r\n  border-radius: 2px;\r\n  background-color: var(--input-background-color);\r\n  font-size: var(--text-size-base);\r\n  font-family: inherit;\r\n}\r\n\r\n.bio-properties-panel-input[type=number],\r\nselect.bio-properties-panel-input,\r\ntextarea.bio-properties-panel-input,\r\n.bio-properties-panel-input[type=text] {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\ntextarea.bio-properties-panel-input {\r\n  min-height: 28px;\r\n}\r\n\r\n.bio-properties-panel-input:focus,\r\n.bio-properties-panel-input:focus-within {\r\n  outline: none;\r\n  background-color: var(--input-focus-background-color);\r\n  border: 1px solid var(--input-focus-border-color);\r\n}\r\n\r\n.bio-properties-panel-textfield:focus-within,\r\n.bio-properties-panel-feel-entry:focus-within {\r\n  --input-background-color: var(--input-focus-background-color);\r\n  --input-border-color: var(--input-focus-border-color);\r\n}\r\n\r\n.bio-properties-panel-input:disabled {\r\n  border-color: var(--input-disabled-border-color);\r\n  background-color: var(--input-disabled-background-color);\r\n  color: var(--input-disabled-color);\r\n}\r\n\r\nselect.bio-properties-panel-input {\r\n  padding: 4px 6px;\r\n}\r\n\r\n.bio-properties-panel-input-monospace {\r\n  font-family: var(--font-family-monospace);\r\n}\r\n\r\n.bio-properties-panel-input[type=\"checkbox\"], .bio-properties-panel-input[type=\"radio\"] {\r\n  margin: 0;\r\n  vertical-align: middle;\r\n}\r\n\r\n.bio-properties-panel-input[type=\"checkbox\"]:focus {\r\n  outline: 2px solid var(--input-focus-border-color);\r\n  outline-offset: 0;\r\n}\r\n\r\n.bio-properties-panel-checkbox > .bio-properties-panel-label {\r\n  display: inline-block;\r\n  font-size: var(--text-size-base);\r\n  margin-left: 6px;\r\n  margin-top: auto;\r\n  vertical-align: middle;\r\n}\r\n\r\n.bio-properties-panel-checkbox-entry + .bio-properties-panel-checkbox-entry  {\r\n  margin-top: -8px;\r\n}\r\n\r\n.bio-properties-panel-checkbox-entry > .bio-properties-panel-description  {\r\n  margin-left: 18px;\r\n}\r\n\r\ntextarea.bio-properties-panel-input {\r\n  resize: vertical;\r\n}\r\n\r\n.bio-properties-panel-entry.has-error .bio-properties-panel-input,\r\n.bio-properties-panel-entry.has-error .bio-properties-panel-feel-editor__open-popup-placeholder {\r\n  border-color: var(--input-error-border-color);\r\n  background-color: var(--input-error-background-color);\r\n}\r\n\r\n.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator {\r\n  border-color: var(--input-error-border-color);\r\n}\r\n\r\n.bio-properties-panel-entry.has-error .bio-properties-panel-input:focus,\r\n.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator:focus {\r\n  border-color: var(--input-error-focus-border-color);\r\n}\r\n\r\n.bio-properties-panel-entry .bio-properties-panel-error {\r\n  color: var(--text-error-color);\r\n  margin: 4px 0;\r\n  font-size: var(--text-size-small);\r\n}\r\n\r\n.bio-properties-panel-simple {\r\n  width: 100%;\r\n  margin-right: 8px;\r\n}\r\n\r\n.bio-properties-panel-simple + .bio-properties-panel-remove-entry {\r\n  margin: auto;\r\n}\r\n\r\n/**\r\n * Toggle Switch\r\n */\r\n.bio-properties-panel-toggle-switch-entry + .bio-properties-panel-toggle-switch-entry  {\r\n  margin-top: -8px;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch-entry > .bio-properties-panel-description {\r\n  margin-left: 38px;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-field-wrapper {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch.inline {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch.inline .bio-properties-panel-field-wrapper {\r\n  margin-left: auto;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch > .bio-properties-panel-label {\r\n  font-size: var(--text-size-base);\r\n}\r\n\r\n.bio-properties-panel-toggle-switch.inline > .bio-properties-panel-label {\r\n  font-size: var(--text-size-small);\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__label {\r\n  margin: 0;\r\n  margin-left: 6px;\r\n  font-size: var(--text-size-base);\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher {\r\n  position: relative;\r\n  width: 32px;\r\n  height: 16px;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher:focus-within {\r\n  outline: 2px solid var(--input-focus-border-color);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type='checkbox'] {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: var(--toggle-switch-off-background-color);\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n  border-radius: 34px;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 12px;\r\n  width: 12px;\r\n  left: 2px;\r\n  bottom: 2px;\r\n  background-color: var(--toggle-switch-switcher-background-color);\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n  border-radius: 50%;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type='checkbox']:checked + .bio-properties-panel-toggle-switch__slider {\r\n  background-color: var(--toggle-switch-on-background-color);\r\n  box-shadow: 0 0 1px ;\r\n}\r\n\r\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type='checkbox']:checked + .bio-properties-panel-toggle-switch__slider:before {\r\n  -webkit-transform: translateX(16px);\r\n  -ms-transform: translateX(16px);\r\n  transform: translateX(16px);\r\n}\r\n\r\n/**\r\n * Collapsible entries\r\n */\r\n.bio-properties-panel-collapsible-entry-entries {\r\n  position: relative;\r\n  display: none;\r\n}\r\n\r\n.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child {\r\n  padding-bottom: 0;\r\n}\r\n\r\n.bio-properties-panel-collapsible-entry-entries.open {\r\n  display: block;\r\n}\r\n\r\n.bio-properties-panel-collapsible-entry-entries  {\r\n  padding-left: 20px;\r\n  margin-bottom: 10px;\r\n  position: relative;\r\n  display: none;\r\n}\r\n\r\n.bio-properties-panel-collapsible-entry-header {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.bio-properties-panel-collapsible-entry-header .bio-properties-panel-collapsible-entry-header-title {\r\n  padding: 2px 24px 2px 32px;\r\n  font-size: var(--text-size-base);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  user-select: none;\r\n}\r\n\r\n.bio-properties-panel-collapsible-entry-arrow {\r\n  position: absolute;\r\n  top: 2px;\r\n  left: 6px;\r\n  padding: 0 3px;\r\n  height: 22px;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  align-self: center;\r\n}\r\n\r\n.bio-properties-panel-remove-entry {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 5px;\r\n  padding: 0;\r\n  width: 22px;\r\n  height: 22px;\r\n  fill: var(--remove-entry-fill-color);\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: none;\r\n  visibility: hidden;\r\n}\r\n\r\n.bio-properties-panel-remove-entry:hover {\r\n  background-color: var(--remove-entry-hover-background-color);\r\n}\r\n\r\n.bio-properties-panel-list-entry-item:hover .bio-properties-panel-remove-list-entry,\r\n.bio-properties-panel-collapsible-entry:hover > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry,\r\n.bio-properties-panel-collapsible-entry:focus-within > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry\r\n{\r\n  visibility: visible;\r\n}\r\n\r\n/* Side line */\r\n.bio-properties-panel-collapsible-entry-entries::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 16px;\r\n  width: 2px;\r\n  top: -6px;\r\n  bottom: 12px;\r\n  background-color: var(--side-line-background-color);\r\n  border-radius: 1px;\r\n}\r\n\r\n/* Side line extension for non-list entry or open list entry positioned as the last one. */\r\n.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child,\r\n.bio-properties-panel-list-entry.open:last-child {\r\n  position: relative;\r\n}\r\n\r\n.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child::after,\r\n.bio-properties-panel-list-entry.open:last-child::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -16px;\r\n  width: 2px;\r\n  top: 0;\r\n  bottom: -4px;\r\n  background-color: var(--side-line-extension-background-color);\r\n  border-radius: 1px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child::after {\r\n  left: -18px;\r\n}\r\n\r\n/*\r\n * List entry\r\n */\r\n.bio-properties-panel-list-entry {\r\n  position: relative;\r\n  margin-right: 5px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.bio-properties-panel-list-entry .bio-properties-panel-entry {\r\n  margin-right: 0;\r\n}\r\n\r\n.bio-properties-panel-list-entry-header {\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: 32px;\r\n}\r\n\r\n/* Nested list dot */\r\n.bio-properties-panel-list-entry::before {\r\n  content: \"\";\r\n  width: 8px;\r\n  height: 8px;\r\n  position: absolute;\r\n  left: -19px;\r\n  top: 13px;\r\n  border-radius: 50%;\r\n  background-color: var(--list-entry-dot-background-color);\r\n}\r\n\r\n.bio-properties-panel-list-entry-header-title {\r\n  display: block;\r\n  margin: auto 0;\r\n  padding: 2px 0;\r\n  font-size: var(--text-size-base);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.bio-properties-panel-list-entry-header-title.open {\r\n  font-weight: 500;\r\n}\r\n\r\n.bio-properties-panel-list-entry-header-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.bio-properties-panel-list-entry-header-buttons > button {\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  align-self: center;\r\n  height: 22px;\r\n  line-height: 22px;\r\n  min-width: 22px;\r\n  margin: 5px;\r\n  padding: 0 3px;\r\n  border: none;\r\n  background: none;\r\n  fill: var(--list-entry-header-button-fill-color);\r\n}\r\n\r\n.bio-properties-panel-list-entry-header-buttons > :last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.bio-properties-panel-list-entry-items {\r\n  padding: 0;\r\n  margin: 0;\r\n\r\n  list-style: none;\r\n}\r\n\r\n.bio-properties-panel-list-entry-items:not(.open) {\r\n  display: none;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-remove-entry {\r\n  margin-right: 1px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry {\r\n  width: 100%;\r\n  margin-right: 4px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header {\r\n  margin-left: -8px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-arrow {\r\n  left: 2px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header-title {\r\n  padding-left: 30px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries {\r\n  padding-left: 10px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries::before {\r\n  left: 4px;\r\n}\r\n\r\n.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry {\r\n  margin-right: 16px;\r\n  padding-left: 6px;\r\n}\r\n\r\n.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry-label {\r\n  color: var(--list-entry-add-entry-label-color);\r\n  padding: 4px 6px 3px 2px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-header-buttons .bio-properties-panel-add-entry:hover {\r\n  background-color: var(--list-entry-add-entry-background-color);\r\n  fill: var(--list-entry-add-entry-fill-color);\r\n}\r\n\r\n.bio-properties-panel-list-entry-item .bio-properties-panel-simple .bio-properties-panel-input {\r\n  border-radius: 0;\r\n  margin-bottom: -2px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item:first-child .bio-properties-panel-simple .bio-properties-panel-input {\r\n  border-top-left-radius: 2px;\r\n  border-top-right-radius: 2px;\r\n}\r\n\r\n.bio-properties-panel-list-entry-item:last-child .bio-properties-panel-simple .bio-properties-panel-input {\r\n  border-bottom-left-radius: 2px;\r\n  border-bottom-right-radius: 2px;\r\n}\r\n\r\n.bio-properties-panel-dropdown-button {\r\n  position: relative;\r\n\r\n  --dropdown-button-margin: 5px;\r\n}\r\n\r\n.bio-properties-panel-dropdown-button:not(.open) .bio-properties-panel-dropdown-button__menu {\r\n  display: none;\r\n}\r\n\r\n.bio-properties-panel-dropdown-button__menu {\r\n  min-width: calc(100% - var(--dropdown-button-margin) * 2);\r\n  max-width: 240px;\r\n\r\n  position: absolute;\r\n  top: calc(100% - var(--dropdown-button-margin));\r\n  right: var(--dropdown-button-margin);\r\n  z-index: 101;\r\n\r\n  background-color: var(--dropdown-item-background-color);\r\n\r\n  padding: 8px 0;\r\n\r\n  box-shadow: 0 1px 4px 0 var(--color-grey-225-10-85), 0 2px 16px 0 var(--color-grey-225-10-75)\r\n}\r\n\r\n.bio-properties-panel-dropdown-button__menu-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 4px 12px;\r\n\r\n  font-size: var(--text-size-small);\r\n  appearance: revert;\r\n  border: unset;\r\n  background: unset;\r\n  text-align: unset;\r\n}\r\n\r\n.bio-properties-panel-dropdown-button__menu-item--separator {\r\n  width: 100%;\r\n  height: 1px;\r\n\r\n  padding: 0;\r\n  margin: 8px 0;\r\n\r\n  background-color: var(--dropdown-separator-background-color);\r\n}\r\n\r\n.bio-properties-panel-dropdown-button__menu-item--actionable {\r\n  font-size: var(--text-size-base);\r\n}\r\n\r\n.bio-properties-panel-dropdown-button__menu-item--actionable:hover {\r\n  background-color: var(--dropdown-item-hover-background-color);\r\n}\r\n\r\n.bio-properties-panel-feel-input {\r\n  position: relative;\r\n}\r\n\r\n.bio-properties-panel-feel-input input {\r\n  padding-right: 2em\r\n}\r\n\r\n.bio-properties-panel-feel-entry .bio-properties-panel-label {\r\n  display: flex;\r\n}\r\n\r\n.bio-properties-panel-feel-icon {\r\n  display: inline-flex;\r\n  height: 18px;\r\n  width: 22px;\r\n  vertical-align: text-bottom;\r\n  padding: 0;\r\n  margin: 0 3px;\r\n  align-items: center;\r\n  align-self: center;\r\n  justify-content: center;\r\n  border: none;\r\n  background: none;\r\n  border-radius: 3px;\r\n}\r\n\r\n.bio-properties-panel-feel-icon.optional {\r\n  cursor: pointer;\r\n  background: var(--feel-background-color);\r\n}\r\n\r\n.bio-properties-panel-feel-icon svg * {\r\n  fill: var(--feel-inactive-color);\r\n}\r\n\r\n.bio-properties-panel-feel-icon:hover {\r\n  background: var(--feel-hover-background-color);\r\n}\r\n\r\n.bio-properties-panel-feel-icon:hover svg * {\r\n  fill: var(--feel-hover-color);\r\n}\r\n\r\n.bio-properties-panel-feel-icon.active {\r\n  background: var(--feel-active-background-color);\r\n}\r\n\r\n.bio-properties-panel-feel-icon.active:hover {\r\n  background: var(--feel-hover-background-color);\r\n}\r\n\r\n.bio-properties-panel-feel-icon.required.active {\r\n  background: none;\r\n}\r\n\r\n.bio-properties-panel-feel-icon.active svg * {\r\n  fill: var(--feel-active-color);\r\n}\r\n\r\n.bio-properties-panel-feel-icon.required.active svg * {\r\n  fill: var(--feel-required-color);\r\n}\r\n\r\n.bio-properties-panel-feel-editor-container {\r\n  position: relative;\r\n}\r\n\r\n.bio-properties-panel-feel-editor-container.active {\r\n  font-family: var(--font-family-monospace);\r\n}\r\n\r\n.bio-properties-panel-feel-container {\r\n  position: relative;\r\n}\r\n\r\n.bio-properties-panel-feel-container .bio-properties-panel-feel-editor-container>div {\r\n  position: static;\r\n  padding-left: 2.4em !important;\r\n  min-height: 28px;\r\n}\r\n\r\n.bio-properties-panel-feel-indicator {\r\n  position: absolute;\r\n  border: 1px solid var(--input-border-color);\r\n  background-color: var(--feel-indicator-background-color);\r\n  border-right: 0px;\r\n  border-radius: 2px 0 0 2px;\r\n  z-index: 1;\r\n  height: 100%;\r\n  width: 2em;\r\n  text-align: center;\r\n  padding: 2px 6px;\r\n}\r\n\r\n.bio-properties-panel-feel-editor-container .cm-scroller {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor .cm-editor {\r\n  background-color: transparent;\r\n}\r\n\r\n\r\n/* @Note(pinussilvestrus): mitigate low contrast - https://github.com/bpmn-io/cm-theme/issues/4 */\r\n.bio-properties-panel-feelers-editor .cm-content ::selection {\r\n  background: var(--feelers-select-color, hsl(205, 100%, 85%));\r\n}\r\n\r\n.bio-properties-panel-feelers-editor .cm-editor.cm-focused {\r\n  background-color: transparent;\r\n}\r\n\r\n.bio-properties-panel-feel-editor-container .bio-properties-panel-input {\r\n  resize: none;\r\n  overflow: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.bio-properties-panel-feel-editor-container,\r\n.bio-properties-panel-feel-editor-container .bio-properties-panel-input,\r\n.bio-properties-panel-feel-container .cm-editor {\r\n  min-height: 100%;\r\n}\r\n\r\n.bio-properties-panel-feel-checkbox,\r\n.bio-properties-panel-feel-toggle-switch {\r\n  padding-top: 1px;\r\n}\r\n\r\n.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active),\r\n.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container,\r\n.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container {\r\n  margin-left: auto;\r\n}\r\n\r\n.bio-properties-panel-tooltip-wrapper {\r\n  text-decoration: underline;\r\n  text-decoration-style: dotted;\r\n  text-underline-offset: 2px;\r\n  font: inherit;\r\n  display: flex;\r\n  justify-content: center;\r\n  width: fit-content;\r\n}\r\n\r\n.bio-properties-panel-tooltip {\r\n  --tooltip-underline-color: var(--color-blue-219-99-53);\r\n  --tooltip-background-color: var(--color-grey-0-0-22);\r\n  --tooltip-link: var(--color-blue-218-100-74);\r\n  --tooltip-code-background-color: var(--color-grey-225-10-97);\r\n  --tooltip-code-border-color: var(--color-grey-225-10-85);\r\n\r\n  display: flex;\r\n  color: var(--color-white, white);\r\n  position: fixed;\r\n  z-index: 1000;\r\n  max-width: 300px;\r\n  font-size: var(--text-size-small);\r\n  font-family: var(--font-family);\r\n}\r\n\r\n.bio-properties-panel-tooltip.right {\r\n  padding-right: 6px;\r\n}\r\n\r\n.bio-properties-panel-tooltip.top {\r\n  flex-direction: column;\r\n}\r\n\r\n.bio-properties-panel-tooltip-content {\r\n  background-color: var(--tooltip-background-color);\r\n  padding: 16px;\r\n  border-radius: 2px;\r\n  font-weight: 400;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.bio-properties-panel-tooltip-content h1 {\r\n  font-size: var(--text-size-base);\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.bio-properties-panel-tooltip-content code,\r\n.bio-properties-panel-tooltip-content pre {\r\n  color: var(--description-color);\r\n  font-family: var(--font-family);\r\n  font-size: var(--text-size-small);\r\n  line-height: var(--line-height-condensed);\r\n  padding: 0 2px;\r\n  background-color: var(--tooltip-code-background-color);\r\n  border: 1px solid var(--tooltip-code-border-color);\r\n  border-radius: 3px;\r\n}\r\n\r\n.bio-properties-panel-tooltip-content pre code {\r\n  border: none;\r\n}\r\n\r\n.bio-properties-panel-tooltip p:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.bio-properties-panel-tooltip p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.bio-properties-panel-tooltip-content a {\r\n  color: var(--tooltip-link);\r\n}\r\n\r\n.bio-properties-panel-tooltip .bio-properties-panel-tooltip-arrow {\r\n  width: 0; \r\n  height: 0; \r\n  border-top: 5px solid transparent;\r\n  border-bottom: 5px solid transparent;\r\n  border-left: 5px solid var(--tooltip-background-color);\r\n  margin-top: 16px;\r\n}\r\n\r\n.bio-properties-panel-tooltip.top .bio-properties-panel-tooltip-arrow {\r\n  margin-top: -3px;\r\n  margin-left: calc(50% - 2.5px);\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor__open-popup-placeholder,\r\n.bio-properties-panel-feel-editor-container .bio-properties-panel-feel-editor__open-popup-placeholder {\r\n  display: none;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  color: hsla(0, 0%, 9%, 0.25);\r\n  padding: 3px 6px 2px;\r\n  border: 1px solid var(--input-border-color);\r\n  border-radius: 2px;\r\n  background-color: var(--input-background-color);\r\n  font-size: var(--text-size-base);\r\n  font-family: inherit;\r\n  width: 100%;\r\n  min-height: 100%;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-input,\r\n.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-input {\r\n  display: none;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-feelers-editor__open-popup-placeholder,\r\n.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-feel-editor__open-popup-placeholder {\r\n  display: flex;\r\n}\r\n\r\n.bio-properties-panel-popup {\r\n  --popup-background-color: hsla(0, 0%, 96%, 1);\r\n  --popup-header-background-color: white;\r\n  --popup-font-color: hsla(0, 0%, 0%, 1);\r\n  --popup-title-color: hsla(0, 0%, 0%, 1);\r\n\r\n  --feel-popup-close-background-color: hsla(219, 99%, 53%, 1);\r\n  --feel-popup-gutters-background-color: hsla(0, 0%, 90%, 1);\r\n\r\n  position: fixed;\r\n  display: flex;\r\n  flex: auto;\r\n  flex-direction: column;\r\n  font-family: IBM Plex Sans, sans-serif;\r\n  padding: 0;\r\n  z-index: 1001;\r\n  box-shadow: 0px 2px 6px 0px hsla(0, 0%, 0%, 0.3);\r\n  background-color: var(--popup-background-color);\r\n  color: var(--popup-font-color);\r\n  height: auto;\r\n  width: auto;\r\n  overflow: hidden;\r\n  font-size: 14px;\r\n}\r\n\r\n.bio-properties-panel-popup h1, \r\n.bio-properties-panel-popup h2, \r\n.bio-properties-panel-popup h3, \r\n.bio-properties-panel-popup h4 {\r\n  font-weight: 500;\r\n  font-size: inherit;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__header,\r\n.bio-properties-panel-popup .bio-properties-panel-popup__body,\r\n.bio-properties-panel-popup .bio-properties-panel-popup__footer {\r\n  padding: 12px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__body:not(:first-child) {\r\n  padding-top: 0;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__header {\r\n  --popup-header-line-height: 16px;\r\n  background-color: var(--popup-header-background-color);\r\n  margin: 0;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: var(--popup-header-line-height);\r\n  text-align: left;\r\n  color: var(--popup-title-color);\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__header.draggable {\r\n  cursor: grab;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__drag-handle {\r\n  display: flex;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__drag-preview {\r\n  width: 1px;\r\n  height: 1px;\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__title {\r\n  margin-left: 8px;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__title::first-letter {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__close {\r\n  margin: -12px;\r\n  margin-left: 12px;\r\n  width: 40px;\r\n  height: 40px;\r\n  border: none;\r\n  background-color: var(--popup-header-background-color);\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__close:hover,\r\n.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {\r\n  background-color: var(--popup-background-color);\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {\r\n  outline-offset: -2px;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__close svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  fill: currentColor;\r\n  margin-top: 2px;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__header .bio-properties-panel-popup__drag-handle svg {\r\n  margin-left: -4px;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__body {\r\n  font-size: inherit;\r\n  height: 100%;\r\n  display: flex;\r\n  overflow: auto;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.bio-properties-panel-popup .bio-properties-panel-popup__footer {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 8px;\r\n}\r\n\r\n.bio-properties-panel-feel-popup {\r\n  min-height: 400px;\r\n  width: fit-content;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-popup__body {\r\n  display: flex;\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.bio-properties-panel-feel-popup__title-link {\r\n  margin-left: 8px; \r\n  display: flex;\r\n}\r\n\r\n.bio-properties-panel-feel-popup__title-link:first-of-type {\r\n  margin-left: auto;\r\n}\r\n\r\n.bio-properties-panel-feel-popup__title-link svg {\r\n  width: var(--popup-header-line-height);\r\n  height: var(--popup-header-line-height);\r\n  fill: currentColor;\r\n  margin: 0 0.5em;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container {\r\n  display: flex;\r\n  min-width: 100%;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-scroller {\r\n  overflow: auto !important;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container {\r\n  width: 100%;\r\n  display: flex;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor {\r\n  display: flex;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor .cm-editor {\r\n  width: 100%;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-input {\r\n  width: 100%;\r\n  resize: none;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  overflow-y: auto\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-open-feel-popup {\r\n  display: none !important;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup,\r\n.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  line-height: 1;\r\n  padding: 2px 4px;\r\n  margin: 3px;\r\n  display: none;\r\n  background: none;\r\n  border: none;\r\n  color: var(--feel-open-popup-color);\r\n  cursor: pointer;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor-container:hover .bio-properties-panel-open-feel-popup,\r\n.bio-properties-panel-feel-container:hover .bio-properties-panel-open-feel-popup,\r\n.bio-properties-panel-feelers-editor-container:focus-within .bio-properties-panel-open-feel-popup,\r\n.bio-properties-panel-feel-container:focus-within .bio-properties-panel-open-feel-popup {\r\n  display: block;\r\n}\r\n\r\n.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup:hover,\r\n.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup:hover {\r\n  color: var(--feel-open-popup-hover-color);\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-popup__footer .bio-properties-panel-feel-popup__close-btn {\r\n  background: var(--feel-popup-close-background-color);\r\n  width: 66px;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  color: white;\r\n  border: none;\r\n  height: 32px;\r\n  cursor: pointer;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor .cm-content {\r\n  padding-left: 4px;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .cm-gutters {\r\n  background-color: var(--feel-popup-gutters-background-color);\r\n  border: none;\r\n  padding: 0;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .cm-gutter {\r\n  min-width: 32px;\r\n}\r\n\r\n.bio-properties-panel-feel-popup .cm-gutters .cm-lineNumbers .cm-gutterElement {\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
